import { render, staticRenderFns } from "./OfferInvitationsList.vue?vue&type=template&id=f5314548&"
import script from "./OfferInvitationsList.vue?vue&type=script&lang=js&"
export * from "./OfferInvitationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports